import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  const [isKDashboard, setIsKDashboard] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isTextSettings, setIsTextSettings] = useState(false);
  const [isLogs, setIsLogs] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "KDashboard") {
      setIsKDashboard(false);
    }
    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }
    if (iscurrentState !== "Text Settings") {
      setIsTextSettings(false);
    }
  }, [history, iscurrentState]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "kdashboard",
      label: "Koottu Dashboard",
      icon: "las la-tachometer-alt",
      link: "/#",
      stateVariables: isKDashboard,
      click: function (e) {
        e.preventDefault();
        setIsKDashboard(!isKDashboard);
        setIscurrentState("KDashboard");
        updateIconSidebar(e);
      }
    },
    {
      id: "Settings",
      label: "Settings",
      icon: "las la-cog",
      link: "/app-settings",
      click: function (e) {
        e.preventDefault();
        setIsSettings(!isSettings);
        setIscurrentState("Settings");
        updateIconSidebar(e);
      }
    },
    {
      id: "Text Settings",
      label: "Text Settings",
      icon: "las la-font",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsTextSettings(!isTextSettings);
        setIscurrentState("Text Settings");
        updateIconSidebar(e);
      },
      stateVariables: isTextSettings,
      subItems: [
        {
          id: "language",
          label: "Language",
          link: "/language",
          parentId: "Text Settings",
        },
        {
          id: "FAQ",
          label: "FAQ Settings",
          link: "/faq-settings",
          parentId: "Text Settings",
        },
        {
          id: "Reasons",
          label: "Reasons",
          link: "/reasons",
          parentId: "Text Settings",
        },
        {
          id: "Privacy Policy",
          label: "Privacy Policy",
          link: "/privacy-policy",
          parentId: "Text Settings",
        },
        {
          id: "Terms of Service",
          label: "Terms of Service",
          link: "/terms-of-service",
          parentId: "Text Settings",
        }
      ],
    },
    {
      id: "users",
      label: "Users",
      icon: "ri-user-2-line",
      link: "/users",
    },
    {
      id: "adminUsers",
      label: "Admin Users",
      icon: "ri-admin-line",
      link: "/admin-users",
    },
    {
      id: "dateLogs",
      label: "Date Logs",
      icon: "ri-calendar-event-line",
      link: "/date-logs",
    },
    {
      id: "gender",
      label: "Gender",
      icon: "ri-genderless-line",
      link: "/gender",
    },
    {
      id: "prompts",
      label: "Prompts",
      icon: "ri-chat-quote-line",
      link: "/prompts",
    },
    {
      id: "likeLogs",
      label: "Like Logs",
      icon: "ri-heart-line",
      link: "/like-logs",
    },
    {
      id: "matchLogs",
      label: "Match Logs",
      icon: "ri-team-line",
      link: "/match-logs",
    },
    {
      id: "moderateMedia",
      label: "Moderate Media",
      icon: "ri-image-edit-line",
      link: "/moderate-media",
    },
    {
      id: "pronoun",
      label: "Pronoun",
      icon: "ri-user-voice-line",
      link: "/pronoun",
    },
    /*{
      id: "posts",
      label: "Posts",
      icon: "ri-file-list-3-line",
      link: "/posts",
    },*/
    {
      id: "subscriptionPlans",
      label: "App Subscription Plans",
      icon: "ri-vip-crown-2-line",
      link: "/subscription-plans",
    },
    {
      id: "tokenPlans",
      label: "Token Plans",
      icon: "ri-coin-line",
      link: "/token-plans",
    },
    {
      id: "referralLogs",
      label: "Referral Logs",
      icon: "ri-share-forward-line",
      link: "/referral-logs",
    },
    {
      id: "reportedIssues",
      label: "Reported Issues",
      icon: "ri-error-warning-line",
      link: "/reported-issues",
    },
    {
      id: "reviewAndRatings",
      label: "Review And Ratings",
      icon: "ri-star-smile-line",
      link: "/review-and-ratings",
    },
    {
      id: "logs",
      label: "Logs",
      icon: "ri-file-list-2-line",
          link: "/#",
          click: function (e) {
            e.preventDefault();
        setIsLogs(!isLogs);
        setIscurrentState("Logs");
        updateIconSidebar(e);
      },
      stateVariables: isLogs,
      subItems: [
        {
          id: "smsLogs",
          label: "SMS Logs",
          link: "/sms-logs",
          parentId: "logs",
          icon: "ri-message-2-line",
        },
        {
          id: "emailLogs",
          label: "Email Logs",
          link: "/email-logs",
          parentId: "logs",
          icon: "ri-mail-line",
        },
          ],
        },
        {
      id: "userMetaData",
      label: "User Meta Data",
      icon: "ri-database-2-line",
      link: "/user-metadata",
    },
    {
      id: "virtualGift",
      label: "Virtual Gift",
      icon: "ri-gift-2-line",
      link: "/virtual-gift",
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
